import { BACKEND_URL } from "./config";

export const BASE_URL = BACKEND_URL;
export const PUBLIC_BASE_URL = `${BASE_URL.replace(/\/+$/, "")}/public`;

export const ADMIN_USER_STORAGE_KEY = "adminUser";
export const FEIDE_USER_STORAGE_KEY = "feideUser";
export const STUDENT_USER_STORAGE_KEY = "studentGateUser";
export const VIPPS_USER_STORAGE_KEY = "vippsUser";

export const AUTH0_BOOTSTRAP_TIMEOUT_MS = 12_000;
export const AUTH0_TOKEN_TIMEOUT_MS = 12_000;

export const noop = () => {};
export const noopAsync = async () => null;

export function scheduleRefresh(jwt, refreshFn) {
  try {
    const { exp } = JSON.parse(atob(jwt.split(".")[1]));
    const ms = Math.max(exp * 1000 - Date.now() - 60_000, 10_000);
    return setTimeout(refreshFn, ms);
  } catch {
    return setTimeout(refreshFn, 4 * 60 * 1000);
  }
}

export function decodeJwtClaims(jwt) {
  if (!jwt || typeof jwt !== "string") return null;
  try {
    const [, payload] = jwt.split(".");
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      "=",
    );
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function buildProviderUser(provider, accessToken, fallbackUser = null) {
  const claims = decodeJwtClaims(accessToken);
  const user = {
    ...(fallbackUser && typeof fallbackUser === "object" ? fallbackUser : {}),
    ...(claims && typeof claims === "object" ? claims : {}),
    provider,
  };
  if (!user.sub && user.external_id) {
    user.sub = user.external_id;
  }
  if (!user.external_id && user.sub) {
    user.external_id = user.sub;
  }
  return user;
}

export async function withTimeout(promise, timeoutMs, timeoutMessage) {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error(timeoutMessage)), timeoutMs);
  });

  try {
    return await Promise.race([promise, timeoutPromise]);
  } finally {
    clearTimeout(timeoutId);
  }
}
